import { locales } from '@/locales';
import { HeaderContainer, type HeaderContainerProps, Icon } from '@bumble/ui-kit';
import header from 'components/lexemes/header';
import { SUPPORT_URL } from 'lib/constants';
import { useRouter } from 'next/router';

export default function Header({ data }: { data: any }) {
  const { downloadUrl, getTheApp, backButtonText } = data || {};

  const router = useRouter();

  function onLanguageChange(event: any) {
    const locale = event;
    let newRoute = `/love-stories/${locale}/${router.asPath}`;
    newRoute = newRoute.replace('//', '/');
    // @ts-ignore
    window.location = newRoute;
    // router.push(`/${router.asPath}`, undefined, { locale: locale });
  }

  const lang = router.locale || 'en';

  const headerMenuItems: HeaderContainerProps['menuItems'] = [
    {
      title: header.lxHeaderItemLabelDate,

      subMenu: {
        title: header.lxHeaderModalDateTitle,
        titleUrl: `/${lang}/date/`,
        description: header.lxHeaderModalDateDescription,
        backButton: {
          text: 'Back',
          // eslint-disable-next-line no-empty-function
          onClick: () => {},
          // onClick: () => onMenuItemClickHandler('date'),
        },
        items: [
          {
            title: header.lxHeaderModalDateComplimentsTitle,
            description: header.lxHeaderModalDateComplimentsDescription,
            url: `/${lang}/features/compliments/`,
          },
          {
            title: header.lxHeaderModalDateIncognitoTitle,
            description: header.lxHeaderModalDateIncognitoDescription,
            url: `/${lang}/features/incognito-mode/`,
          },
          {
            title: header.lxHeaderModalDateVideoChatTitle,
            description: header.lxHeaderModalDateVideoChatDescription,
            url: `/${lang}/features/video-chat/`,
          },
          {
            title: header.lxHeaderModalDateTravelModeTitle,
            description: header.lxHeaderModalDateTravelModeDescription,
            url: `/${lang}/features/travel-mode/`,
          },
          {
            title: header.lxHeaderModalDateSnoozeModeTitle,
            description: header.lxHeaderModalDateSnoozeModeDescription,
            url: `/${lang}/features/snooze-mode/`,
          },
          {
            title: header.lxHeaderModalDateSuperSwipeTitle,
            description: header.lxHeaderModalDateSuperSwipeDescription,
            url: `/${lang}/features/superswipe/`,
          },
        ],
      },
      // onClick: () => onMenuItemClickHandler('date'),
    },
    {
      title: header.lxHeaderItemLabelFriends,
      subMenu: {
        title: header.lxHeaderModalFriendsTitle,
        titleUrl: `${lang}/bff`,
        description: header.lxHeaderModalFriendsDescription,
        backButton: {
          text: 'Back',
          // eslint-disable-next-line no-empty-function
          onClick: () => {},
          // onClick: () => onMenuItemClickHandler('friends'),
        },
        items: [
          {
            title: header.lxHeaderModalFriendsPlansTitle,
            description: header.lxHeaderModalFriendsPlansDescription,
            iconName: Icon.Name.Calendar,
            url: '/bff/plans',
          },
          {
            title: header.lxHeaderModalFriendsCommunityLeadersTitle,
            description: header.lxHeaderModalFriendsCommunityLeadersDescription,
            iconName: Icon.Name.GenericHeart,
            url: '/bumble-honey-ambassadors',
            // onClick: () => onMenuItemClickHandler('ambassadors'),
          },
        ],
      },
    },
    {
      title: header.lxHeaderItemLabelStories,
      isActive: true,
      subMenu: {
        title: header.lxHeaderModalStoriesTitle,
        description: header.lxHeaderModalStoriesDescription,
        backButton: {
          text: 'Back',
          // eslint-disable-next-line no-empty-function
          onClick: () => {},
          // onClick: () => onMenuItemClickHandler('stories'),
        },
        items: [
          {
            title: header.lxHeaderModalStoriesLoveStoriesTitle,
            description: header.lxHeaderModalStoriesLoveStoriesDescription,
            url: '/love-stories',
          },
          {
            title: header.lxHeaderModalStoriesSeasonalTitle,
            description: header.lxHeaderModalStoriesSeasonalDescription,
            url: '/date/seasonal',
          },
          {
            title: header.lxHeaderModalStoriesFriendshipHubTitle,
            description: header.lxHeaderModalStoriesFriendshipHubDescription,
            url: '/bff/friendship',
          },
        ],
      },
    },
    // {
    //     title: header.lxHeaderItemLabelBuzz,
    //     url: '/the-buzz/',
    //     onClick: () => onMenuItemClickHandler('blog'),
    // },
    {
      title: header.lxHeaderItemLabelSafety,
      url: 'https://safety.bumble.com',
      // onClick: () => onMenuItemClickHandler('safety'),
    },
    {
      title: header.lxHeaderItemLabelSupport,
      url: SUPPORT_URL,
      // onClick: () => onMenuItemClickHandler('support'),
    },
  ];

  return (
    <div>
      {/* @ts-ignore */}
      <HeaderContainer
        menuItems={headerMenuItems}
        backButtonText={backButtonText}
        languages={locales}
        logoA11yLabel="Bumble"
        downloadUrl={downloadUrl}
        // JS-30493: Bumble Web is discontinued. @bumble/ui-kit's HeaderContainer
        // requires signInText and hardcodes the sign-in button with no prop to
        // disable it, so we pass an empty label and hide the button via CSS in
        // styles/ui-kit-overrides.css until JS-30514 removes it from ui-kit properly.
        signInText=""
        getTheAppText={getTheApp}
        onLanguageChange={onLanguageChange}
        lang={router.locale}
      />
    </div>
  );
}
